import WvusClientLogger from 'wvus-client-logger';
const loggerKey = process.env.WV_LOGGLY_KEY;
const goalTrackerEnv = process.env.GOALTRACKER_ENV;

export function getClientLoggerInstance(opts = {}) { 
  // Return instance if it exist
  if (window.wvusLogger) {
    return window.wvusLogger;
  }

  const { goalRef="" } = opts;
    
  // Create new instance
  const webproperty = "goal_tracker";
  const source = `Goal Tracker - ${goalRef}`;
  const sendConsoleErrors = true;

  return  new WvusClientLogger({
    logglyKey: loggerKey, 
    webProperty: webproperty, 
    source: source,
    env: goalTrackerEnv,
    sendConsoleErrors: sendConsoleErrors,
    separateInstance: true
  });
}  